export function truncateText(text: string, maxLength: number): string {
  if (!text || text.length <= maxLength) return text || '';

  const truncated = text.slice(0, maxLength - 3);
  const lastSpace = truncated.lastIndexOf(' ');

  return (lastSpace > 0 ? truncated.slice(0, lastSpace) : truncated) + '...';
}
